export const INPUT_ERRORS = [
	'INVALID_DATE_FORMAT',
	'INVALID_MONTH',
	'INVALID_DAY_NUMBER',
	'INVALID_DAY_OF_MONTH',
	'DATETIME_INVALID_FORMAT',
	'TIME_FORMAT_INVALID',
];
export const HOUR_ERRORS = ['INVALID_HOUR'];
export const MINUTES_ERRORS = ['INVALID_MINUTES'];
export const SECONDS_ERRORS = ['INVALID_SECONDS'];

export const FIELD_HOURS = 'HOURS';
export const FIELD_MINUTES = 'MINUTES';
export const FIELD_SECONDS = 'SECONDS';
